// tslint:disable-next-line:import-name
import MenuProductCardContainer from './MenuProductCard';
import MenuProductCardUI from './MenuProductCardUI';
var MenuProductCard = {
    Container: MenuProductCardContainer,
    UI: MenuProductCardUI
};
export default MenuProductCard;
